var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M16.087 20.521c-2.452 0-5.414-1.617-8.121-4.315C5.25 13.49 3.65 10.52 3.65 8.05c0-1.389.405-2.408 1.354-3.287.061-.053.114-.106.167-.15.562-.527 1.151-.79 1.687-.782.572.018 1.099.325 1.556.993l1.758 2.55c.5.72.58 1.572-.167 2.337l-.633.641c-.193.194-.228.405-.097.642.352.615.932 1.275 1.75 2.092.746.747 1.722 1.547 2.153 1.81.237.132.448.097.641-.096l.642-.633c.765-.747 1.626-.668 2.338-.167l2.549 1.758c.668.457.993.984.993 1.556 0 .536-.255 1.116-.782 1.687-.044.053-.097.105-.15.167-.887.958-1.916 1.354-3.322 1.354Zm.009-1.063c.993-.009 1.863-.343 2.522-1.055.035-.052.062-.079.106-.131.299-.326.448-.65.448-.94 0-.282-.123-.52-.404-.704l-2.54-1.705c-.326-.22-.695-.255-1.055.105l-.712.721c-.527.527-1.204.51-1.732.15-.615-.422-1.625-1.284-2.425-2.092-.791-.8-1.609-1.75-2.03-2.365-.36-.527-.378-1.204.149-1.731l.72-.712c.36-.36.326-.73.106-1.055l-1.705-2.54C7.351 5.114 7.122 5 6.84 5c-.281 0-.615.15-.94.448-.045.035-.08.07-.132.106-.712.659-1.046 1.52-1.055 2.496-.027 2.25 1.714 5.124 4.034 7.435 2.303 2.312 5.107 4 7.348 3.973Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.b5e1eda01156abb3d7c2fa6459b87353.svg";
export { ForwardRef as ReactComponent };